import { Typography } from '@mui/material';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { useMemo } from 'react';

import type { QBValueDisplayProps } from './QueryBuilder.types';

dayjs.extend(utc);

export const QueryBuilderValueDisplay = function QueryBuilderValueDisplay({
  valueType,
  selectedValue,
  className,
  onEdit
}: QBValueDisplayProps) {
  const displayValue = useMemo(() => {
    switch (valueType) {
      case 'datetime':
        return dayjs
          .utc(selectedValue as string)
          .local()
          .format('MM/DD/YYYY HH:mm');
      case 'bool':
        return selectedValue === 'true' || selectedValue === 'Yes'
          ? 'Yes'
          : 'No';
      default:
        if (selectedValue === null) {
          return (
            <Typography sx={{ fontStyle: 'italic' }} color="textPrimary_a50">
              [Empty]
            </Typography>
          );
        }
        return selectedValue;
    }
  }, [valueType, selectedValue]);

  return (
    <Typography className={className} component="span" onClick={onEdit}>
      {displayValue}
    </Typography>
  );
};

export default QueryBuilderValueDisplay;
